import React from 'react';
import Modal from 'react-modal';
import { FaSpinner, FaCog, FaCircleNotch } from 'react-icons/fa';
import './WaitingModal.css';

const LoadingModal = ({ 
  isActive, 
  message = "Loading...", 
  submessage = "Just a moment",
  spinnerType = "default" // default, cog, notch
}) => {
  const getSpinnerIcon = () => {
    switch (spinnerType) {
      case 'cog':
        return <FaCog size={32} className="waiting-modal__spinner waiting-modal__spinner--cog" />;
      case 'notch':
        return <FaCircleNotch size={32} className="waiting-modal__spinner waiting-modal__spinner--notch" />;
      default:
        return <FaSpinner size={32} className="waiting-modal__spinner waiting-modal__spinner--default" />;
    }
  };

  return (
    <Modal
      isOpen={isActive}
      onRequestClose={() => {}}
      contentLabel="Loading Modal"
      className="waiting-modal__content"
      overlayClassName="waiting-modal__overlay"
      style={{
        overlay: {
          zIndex: 9999,
        },
        content: {
          zIndex: 10000,
        },
      }}
    >
      <div className="waiting-modal__container">
        <div className="waiting-modal__icon-container">
          {getSpinnerIcon()}
        </div>
        
        <div className="waiting-modal__text-container">
          <h3 className="waiting-modal__message">{message}</h3>
          <p className="waiting-modal__submessage">{submessage}</p>
        </div>
        
        <div className="waiting-modal__progress-bar">
          <div className="waiting-modal__progress-fill"></div>
        </div>
      </div>
    </Modal>
  );
};

export default LoadingModal;
